var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.876 1H28.3933C28.5542 1 28.7085 1.06391 28.8222 1.17766C28.936 1.29142 28.9999 1.44571 28.9999 1.60659V14.63C28.9999 15.8221 28.5263 16.9653 27.6834 17.8083C26.8405 18.6512 25.6972 19.1248 24.5051 19.1248H19.1247C17.9326 19.1248 16.7893 18.6512 15.9464 17.8083C15.1034 16.9653 14.6299 15.8221 14.6299 14.63V1.60659C14.6299 1.44571 14.6938 1.29142 14.8075 1.17766C14.9213 1.06391 15.0756 1 15.2365 1H17.7538",
    stroke: "#7F7F7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.33594 19.5069V25.8639C4.33594 28.1821 5.25685 30.4054 6.89609 32.0446C8.53532 33.6839 10.7586 34.6048 13.0768 34.6048C15.3951 34.6048 17.6184 33.6839 19.2576 32.0446C20.8968 30.4054 21.8177 28.1821 21.8177 25.8639V22.655M14.6297 13.9869V14.6299C14.6297 15.822 15.1033 16.9653 15.9462 17.8082C16.7891 18.6512 17.9324 19.1247 19.1245 19.1247H24.5049C25.697 19.1247 26.8403 18.6512 27.6832 17.8082C28.5262 16.9653 28.9997 15.822 28.9997 14.6299V13.9869H14.6297Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.33622 19.5069C6.17877 19.5069 7.67244 18.0132 7.67244 16.1707C7.67244 14.3281 6.17877 12.8345 4.33622 12.8345C2.49368 12.8345 1 14.3281 1 16.1707C1 18.0132 2.49368 19.5069 4.33622 19.5069Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.818 22.6551C21.2665 22.6558 20.7324 22.4614 20.3105 22.1061C19.8886 21.7508 19.6061 21.2577 19.513 20.714L19.2461 19.1248H24.4021L24.0988 20.7383C24.0024 21.2739 23.7215 21.7589 23.3049 22.109C22.8883 22.4591 22.3622 22.6523 21.818 22.6551Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialty);
export default __webpack_public_path__ + "static/media/specialty.cba1fecfa410c06c47112591baa06670.svg";
export { ForwardRef as ReactComponent };